const BROWSER_DEVICE_GUID_KEY = "atlas_browser_device_guid";

function generateUUID() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Get or create a persistent UUID identifying this browser installation/device.
 */
export function getBrowserDeviceGuid() {
  if (typeof window === "undefined") return "";
  try {
    let guid = localStorage.getItem(BROWSER_DEVICE_GUID_KEY);
    if (!guid || typeof guid !== "string" || guid.trim().length < 10) {
      guid = generateUUID();
      localStorage.setItem(BROWSER_DEVICE_GUID_KEY, guid);
    }
    return guid;
  } catch {
    return generateUUID();
  }
}
